module.exports = __webpack_public_path__ + "img/16.01567515.jpg";